import { SlideShell } from '../pages/wrapped/WrappedSlides'

const BG = '#0A0A0A'
const CARD = '#13120A'

/**
 * Full-screen digest-shaped placeholder — use as Suspense fallback so navigating
 * from the dashboard never flashes the generic PageSkeleton (wrong layout/colors).
 * Matches the loading branch inside DigestPage for a seamless handoff.
 */
export default function DigestLoadingSkeleton() {
  return (
    <div className="dark fixed inset-0 z-[100] flex items-center justify-center" style={{ backgroundColor: BG }}>
      <div className="w-full max-w-[440px] px-4">
        <SlideShell className="border-white/[0.08]" style={{ backgroundColor: CARD }}>
          <div className="space-y-4 p-6 animate-pulse">
            <div className="h-3 w-20 rounded bg-white/[0.06]" />
            <div className="mt-8 h-6 w-48 rounded bg-white/[0.06]" />
            <div className="h-4 w-64 rounded bg-white/[0.04]" />
            <div className="mt-8 grid grid-cols-3 gap-2.5">
              {[0, 1, 2].map((i) => (
                <div key={i} className="h-16 rounded-xl bg-white/[0.04]" />
              ))}
            </div>
            <div className="mt-12 h-10 w-24 rounded-lg bg-white/[0.06]" />
          </div>
        </SlideShell>
      </div>
    </div>
  )
}
